import customTheme from "../../../theme";

/** Estilos provisionales en login */
const seleciconarSolucionStyles = {
  
  breadCrumb: {
    maxHeight: customTheme.spacing(20),
    height: "25%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    borderBottom: "1px solid #e5e5e5",
  },

  headerTitle: {
    fontFamily: "SegoeUI-Bold",
    fontSize: {xs:"32px", sm:"56px"},
    color: "#2e3e93",
  },

};

export default seleciconarSolucionStyles;
